import React from 'react';
import Button from '../Button/Button';
import Input from '../Input/Input';

function SearchInput({
  actionLabel = 'Rechercher',
  className = '',
  fullWidth = false,
  label = 'Rechercher',
  onChange,
  onKeyDown,
  onSubmit,
  placeholder,
  showAction = Boolean(onSubmit),
  value,
  ...rest
}) {
  const submitSearch = () => {
    onSubmit?.(value);
  };

  return (
    <div className={[
      'custom-search-input',
      fullWidth ? 'custom-search-input--full' : '',
      className,
    ].filter(Boolean).join(' ')} role="search">
      <Input
        fullWidth
        label={label}
        value={value}
        onChange={onChange}
        onKeyDown={(event) => {
          onKeyDown?.(event);
          if (!event.defaultPrevented && event.key === 'Enter' && onSubmit) {
            submitSearch();
          }
        }}
        placeholder={placeholder}
        type="search"
        {...rest}
      />
      {showAction && (
        <Button className="custom-search-input__action" variant="primary" onClick={submitSearch}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export default SearchInput;
